import React from 'react';
import Crashed from './Crashed.jsx';

/**
 * Het vangnet om de app heen.
 *
 * Belangrijk dat dit een eigen component ís en niet iets in App zelf: React vangt
 * met een grensbewaker alleen fouten uit de kinderen, nooit uit zijn eigen render.
 * Zat het in App, dan bleef een fout in App gewoon een wit scherm geven. (Vraag
 * niet hoe ik daarachter kwam.)
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[paal] onderuit gegaan tijdens renderen:', error, info);
  }

  reload = () => {
    // De krabbel waar je mee bezig was is al opgeslagen: de app doet dat op een
    // timer en nog eens bij het verlaten van de pagina, en herladen telt als
    // verlaten. Dus gewoon opnieuw beginnen.
    window.location.reload();
  };

  render() {
    if (this.state.error) return <Crashed error={this.state.error} onReload={this.reload} />;
    return this.props.children;
  }
}
